import React, { useEffect } from "react";
import Style from "./ButtonStartNaviComponent.module.scss";
import { IAuftrag } from "../../types/Types";


interface ButtonStartNaviComponentProps {
  // onLocationSelected?: (uid: string) => void;
  auftrag: IAuftrag
}

const ButtonStartNaviComponent: React.FC<ButtonStartNaviComponentProps> = ({ auftrag }) => {

  const address = encodeURIComponent(auftrag.strasse_lieferadresse + " " + auftrag.hausnummer_lieferadresse + " " + auftrag.postleitzahl_lieferadresse + " " + auftrag.stadt_lieferadresse);
  //const mapsAppUrl = `comgooglemaps://?daddr=${address}&directionsmode=driving`;

  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  const androidUrl = `intent://maps.google.com/maps?daddr=${address}&directionsmode=driving#Intent;package=com.google.android.apps.maps;scheme=https;end`;
  const iosUrl = `comgooglemaps://?daddr=${address}&directionsmode=driving`;
  const webUrl = `https://www.google.com/maps/dir/?api=1&destination=${address}&travelmode=driving`;

  const finalUrl = isAndroid ? androidUrl : isIOS ? iosUrl : webUrl;

  useEffect(() => {
  }, []);
  return (
    <a
      href={finalUrl}
      className="btn-sm bg-green-600 hover:bg-green-700 text-white rounded inline-block "
    >
      <span className={Style.buttonStartNaviComponent}>
       <i className="bi bi-sign-turn-right-fill"></i>
      </span>
    </a>
  );
}

export default ButtonStartNaviComponent;